/* global axios */
import ApiClient from './ApiClient';

class ContactGroupsAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  show(contactId) {
    return axios.get(`${this.url}/${contactId}/group`);
  }

  create({ inboxId, name, description, participantContactIds }) {
    return axios.post(`${this.url}/create_group`, {
      inbox_id: inboxId,
      name,
      description,
      participant_contact_ids: participantContactIds,
    });
  }

  updateMetadata(contactId, { name, description, announcementOnly }) {
    return axios.patch(`${this.url}/${contactId}/update_group`, {
      name,
      description,
      announcement_only: announcementOnly,
    });
  }

  disband(contactId) {
    return axios.delete(`${this.url}/${contactId}/disband_group`);
  }

  addMembers(contactId, contactIds) {
    return axios.post(`${this.url}/${contactId}/group_add_members`, {
      contact_ids: contactIds,
    });
  }

  removeMember(contactId, memberContactId) {
    return axios.delete(
      `${this.url}/${contactId}/group_members/${memberContactId}`
    );
  }

  createInvite(contactId) {
    return axios.post(`${this.url}/${contactId}/group_invite`);
  }

  revokeInvite(contactId) {
    return axios.delete(`${this.url}/${contactId}/group_invite`);
  }
}

export default new ContactGroupsAPI();
